// PARAQTA · «Шырақтың алғашқы 3 күні» (founder мокабы 17.10.2026) — ТЕК жалаумен.
// ?journey=1 → осы браузерде қосылады (localStorage pq_journey), ?journey=0 → өшеді. Әдепкіде ӨШІК:
// жалау жоқта сайт бұрынғыдай жұмыс істейді (core/flags.js үлгісі).
//
// «Жаңа адам» = жалау қосулы кезде алғаш тексергенде /api/onboarding/status needs=true болған (бұрын оқымаған).
// «Күн» = аяқталған оқу сессиясы бар ӘРТҮРЛІ күн (жергілікті тізім pq_journey_days_<uid>; ең кемі серверден
// /api/sessions/stats streak-пен салыстырылады). Алғашқы 3 күн бітпейінше жетістік/PWA/push терезелері шықпайды
// (ui-queue.claimSecondary + celebrations.maybeCelebrateAchievements осыны сұрайды) — 4-күні өздігінен шығады.
//
// Тексеру үшін: ?jdone=N (0–3) — «N күн бұрын оқыған» деп жазып қояды (келесі сессия N+1-күн болады); ?journey=0 — тазалау.
import { track } from './track.js';

const FLAG = 'pq_journey';
const todayStr = () => { const d = new Date(); return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); };
const uid = () => { try { return (window.currentUser && window.currentUser.telegram_id) || 'anon'; } catch (_) { return 'anon'; } };
const kNew = () => 'pq_journey_new_' + uid();
const kDays = () => 'pq_journey_days_' + uid();
const get = (k) => { try { return localStorage.getItem(k); } catch (_) { return null; } };
const set = (k, v) => { try { localStorage.setItem(k, v); } catch (_) {} };

export function journeyOn() {
  try {
    const q = (/[?&]journey=([01])/.exec(location.href) || [])[1];
    const jd = (/[?&]jdone=([0-3])/.exec(location.href) || [])[1];
    if (jd != null) sessionStorage.setItem('pq_jdone', jd);                     // адрес қайта жазылмай тұрып ұстаймыз
    // 18.10: founder — бәріне қосулы (әдепкі). ?journey=0 осы браузерде өшіреді, ?journey=1 қайта қосады.
    if (q === '1') localStorage.removeItem(FLAG);
    if (q === '0') {
      Object.keys(localStorage).filter(k => k.startsWith('pq_journey_')).forEach(k => localStorage.removeItem(k));
      localStorage.setItem(FLAG, '0');
    }
    return localStorage.getItem(FLAG) !== '0';
  } catch { return false; }
}

// ── күндер ────────────────────────────────────────────────────────────────
export function daysList() {
  try { const a = JSON.parse(get(kDays()) || '[]'); return Array.isArray(a) ? a : []; } catch (_) { return []; }
}
export const daysDone = () => daysList().length;
export const countedToday = () => daysList().includes(todayStr());
const isNewcomer = () => get(kNew()) === '1';

/** Жалау қосулы әрі адам «жаңа» ма. (Онбординг шешімі белгілі болғаннан кейін дұрыс.) */
export function journeyActive() { return journeyOn() && isNewcomer(); }

/** Бүгінгі аяқталған сессия кезек күн ретінде саналуы керек пе (немесе бүгін әлдеқашан саналған ба). */
export function inJourney() {
  if (!journeyActive()) return false;
  const n = daysDone();
  return n < 3 || (n === 3 && countedToday());
}

/** Жетістік/PWA/push/ескі арна терезелерін ұстап тұру керек пе (алғашқы 3 күн + 3-күннің соңына дейін). */
export function journeySuppress() { return inJourney(); }

/** Шырағың сөнген бе: жаңа адам, әлі бірде-бір сессия жоқ. */
export function shyraqOut() { return journeyActive() && daysDone() === 0; }

/** Жалау қосулы болса, онбординг орнына шақырылады: қай адам «жаңа» екенін бір рет анықтайды. */
let _initP = null;
export function journeyInit() { return _initP || (_initP = _journeyInit()); }
async function _journeyInit() {
  if (!journeyOn()) return false;
  let force = null;
  try { force = sessionStorage.getItem('pq_jdone'); sessionStorage.removeItem('pq_jdone'); } catch (_) {}
  if (force != null) {
    const n = Number(force), out = [];
    for (let i = n; i >= 1; i--) { const d = new Date(); d.setDate(d.getDate() - i); out.push(d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0')); }
    set(kNew(), '1'); set(kDays(), JSON.stringify(out));
    return true;
  }
  if (get(kNew()) != null) return isNewcomer();
  let needs = false;
  try {
    const r = await fetch('/api/onboarding/status', { credentials: 'include' });
    const d = r.ok ? await r.json() : null;
    needs = !!(d && d.needs);
  } catch (_) { return false; }                 // желі жоқ — шешпейміз, келесі жолы
  set(kNew(), needs ? '1' : '0');
  return needs;
}

/**
 * Аяқталған сессияны жазу. Қайтарады: { n, repeat }. n — осы күннің реті (1–3), repeat — бүгін әлдеқашан саналған.
 * Сервер streak-ы (бар болса) жергілікті тізімнен үлкен болса — соны алады (құрылғы ауысқанда).
 */
export async function recordSession() {
  const list = daysList(), t = todayStr();
  if (list.includes(t)) return { n: list.length, repeat: true };
  list.push(t); set(kDays(), JSON.stringify(list));
  let n = list.length;
  try {
    const r = await fetch('/api/sessions/stats', { credentials: 'include' });
    const d = r.ok ? await r.json() : null;
    const st = Number(d && d.streak) || 0;
    if (st > n && st <= 3) n = st;
  } catch (_) {}
  return { n: Math.min(3, n), repeat: false };
}

/** Өлшеу: track('journey_step', {day, step}). */
export function jstep(day, step, extra) { try { track('journey_step', Object.assign({ day, step }, extra || {})); } catch (_) {} }

/** Дүкенде қазір неше адам оқып отыр (/api/rooms, ағымдағы бөлме). */
export async function liveCount() {
  try {
    const r = await fetch('/api/rooms', { credentials: 'include' });
    const d = r.ok ? await r.json() : null;
    if (!d || !Array.isArray(d.rooms)) return 0;
    const room = d.rooms.find(x => x.code === d.current) || d.rooms[0];
    return Number(room && room.count) || 0;
  } catch (_) { return 0; }
}

/** Қазіргі күннің реті (1–3): бүгін әлдеқашан саналған болса — сол, әйтпесе келесі. */
export const currentDay = () => Math.min(3, countedToday() ? daysDone() : daysDone() + 1);
